import { Card } from 'antd';
import React from 'react';
import AdminLayoutWrapper from './AdminLayoutWrapper';




const Admin = () => {
  return (
    <AdminLayoutWrapper>
      <h1>Hello Admin</h1>
      <p>Quick Access</p>
      <Card>
        <p>Manage API</p>
        <p>Manage Teams</p>
      </Card>
    </AdminLayoutWrapper>
  )
}


export default Admin;